import { memo, useEffect } from 'react';
import Lottie from 'react-lottie';
import styled from '@emotion/styled';
import { disableScrollLock, enableScrollLock } from '~/utils';
import LoadingLottie from '~/assets/lottieJson/chat_page_loading.json';
import useChatPageLoadingStatus from '~/store/useChatPageLoadingStatusStore';

const ChatPageLoadingLayout = memo(function ChatPageLoadingLayout() {
  const { isChatPageLoading, loadingBg } = useChatPageLoadingStatus();

  useEffect(() => {
    enableScrollLock();
    return disableScrollLock();
  }, []);

  return isChatPageLoading ? (
    <FullScreenContainer>
      <Wrapper>
        <FullScreenLoadingBg src={loadingBg} />
        <FullScreenFlexWrapper>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: LoadingLottie,
            }}
            style={{
              width: '200px',
              height: '200px',
            }}
          />
          <LoadingText>Loading....</LoadingText>
        </FullScreenFlexWrapper>
      </Wrapper>
    </FullScreenContainer>
  ) : null;
});

export default ChatPageLoadingLayout;

export const FullScreenContainer = styled.div`
  display: flex;
  position: fixed;
  z-index: 1;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100%;
  background-position: center;
  inset: 0;
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 768px;
  height: 100%;
`;

const FullScreenLoadingBg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FullScreenFlexWrapper = styled.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(100% + 2px);
  height: 100%;
  backdrop-filter: blur(20px);
`;

const LoadingText = styled.span`
  ${({ theme }) => theme.fontStyle.title.section24_medium}
`;
